/**
 * Rail-driving events for the Patient details section.
 *
 * PD_V2_EDIT — fired by the middle-column FIELD/VALUE table when the
 *   reviewer clicks any row. Payload is `{ focusField, focusAt }` where
 *   `focusField` names one of the editable form fields (firstName,
 *   lastName, gender, dateOfBirth, email) so the rail can move focus
 *   there on mount. Read-only rows (Mobile, Work email) send no
 *   `focusField` — the rail opens without auto-focusing an input.
 *
 * PD_V2_CLOSE — the editor emits this on Cancel / successful Save so
 *   the shell tears the rail column down and the content column
 *   reclaims the width.
 *
 * PD_V2_REFRESH — the editor fires this after a successful save so
 *   the middle-column table re-reads the patient record and mirrors
 *   the new values.
 */
export const PD_V2_EDIT = "PD_V2_EDIT";
export const PD_V2_CLOSE = "PD_V2_CLOSE";
export const PD_V2_REFRESH = "PD_V2_REFRESH";
